<template>
  <div>
    <div class="table_th">
      <div style="width:15%">
        {{ $t(`lang.str_bet`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_balloon_size`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_balloon_result`) }}
      </div>
      <div style="width:20%">
        {{ $t(`lang.str_game_win_result`) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:15%">
        <div>{{ bet_amount }}</div>
      </div>
      <div style="width:20%">
        <div>{{ balloon_size }}x</div>
      </div>
      <div style="width:20%">
        <div> {{ balloon_result }}</div>
      </div>
      <div :class="{yellow_color:checkWin()}" style="width:20%">
        <div>{{ checkWin()? $t(`lang.str_t`):$t(`lang.str_f`) }}</div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3001",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    bet_amount:0,
    balloon_size:0,
    balloon_result:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    checkWin()
    {
      return this.balloon_result > 0;
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3001.vue